<template>
    <div class="backBox">
        <div class="pad">
            <div class="detail-box">
                <div v-if="type===1" class="detail-title">
                    <img src="../../assets/storage/wait-take.png">
                    <div class="status">存包中</div>
                    <div class="detail">您的物品正在存放中</div>
                </div>
                <div v-if="type===2" class="detail-title">
                    <img src="../../assets/storage/take-out.png">
                    <div class="status">已完成</div>
                    <div class="detail">您存放的物品已被取出</div>
                </div>
                <table class="content-table">
                    <tr>
                        <th>存放地点：</th>
                        <td>{{detailInfo.location}}</td>
                    </tr>
                    <tr>
                        <th>存包格：</th>
                        <td class="num-td" style="color: #000000;font-weight: bolder">{{detailInfo.number}}#</td>
                    </tr>
                    <tr>
                        <th>存放时间：</th>
                        <td class="num-td">{{type===1?detailInfo.gmtCreated:detailInfo.checkInTime}}</td>
                    </tr>
                    <tr v-if="type===2">
                        <th>取出时间：</th>
                        <td class="num-td">{{detailInfo.checkOutTime}}</td>
                    </tr>
                    <tr>
                        <th>存储时长：</th>
                        <td >{{detailInfo.timeDiff}}</td>
                    </tr>
                    <tr>
                        <th>存包编号：</th>
                        <td class="num-td">{{detailInfo.tradeNo}}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api/storage";
import { Toast } from "vant";

export default {
    name: "CabinetDetail",
    data(){
        return{
            type:this.$route.query.type,
            id:this.$route.query.id,
            detailInfo:{}
        }
    },
    created() {
        if(this.type===1){
            this.getCabinetDetail();
        }else {
            this.getTakeOutCabinetDetail();
        }
    },
    methods:{
        getCabinetDetail(){
            api.getDetail({
                authId:this.id
            }).then(res=>{
                if(res.result===0){
                    this.detailInfo=res.data;
                }else {
                    Toast(res)
                }
            })
        },
        getTakeOutCabinetDetail(){
            api.getTakeOutDetail({
                recordId:this.id
            }).then(res=>{
                if(res.result===0){
                    this.detailInfo=res.data;
                }else {
                    Toast(res)
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import "../../../static/less/common";
.detail-box{
    position: relative;
    margin-top: 44px;
    box-shadow: 0 2px 20px 0 rgba(0,0,0,0.05);
    padding: 0 20px 80px 20px;
}
.detail-title{
    text-align: center;
    img{
        width: 60px;
        margin-top: -30px;
    }
    .status{
        font-size: 16px;
        color: #333333;
        line-height: 32px;
    }
    .detail{
        font-size: 12px;
        color: #999999;
    }
}
.content-table{
    width: 100%;
    margin-top: 30px;
    font-size: 14px;
    text-align: left;
    th{
        color: #999999;
        padding: 10px 0;
        font-weight: unset;
        width: 80px;
    }
    td{
        color: #333333;
        padding: 10px 0;
    }
    .num-td{
        padding: 10px 0 8px 0;
    }
}
</style>
